import Wall from "@/views/Wall.vue";
import NotFound from "@/views/NotFound.vue";

export default [
	{
		path: "/",
		name: "Home",
		component: Wall,
		meta: {
			title: "$vuetify.layout.menu.community",
			layout: "default",
		},
	},
	{
		path: "/groups",
		name: "Groups",
		meta: {
			title: "$vuetify.layout.menu.groups",
			layout: "default",
		},
		redirect: 'groups/list',
		component: () =>
			import(/* webpackChunkName: "groups" */ "@/views/Groups.vue"),
		children: [
			{
				path: "list",
				name: "Groups.Index",
				meta: {
					title: "$vuetify.layout.menu.groups",
					layout: "default",
				},
				component: () =>
					import(/* webpackChunkName: "groups-index" */ "@/views/groups/GroupsIndex.vue"),
			},
			{
				path: "user-groups",
				name: "Groups.UserGroups",
				meta: {
					title: "$vuetify.layout.menu.yourGroups",
					layout: "default",
				},
				component: () =>
					import(/* webpackChunkName: "user-groups" */ "@/views/groups/UserGroups.vue"),
			},
			{
				path: "requested-groups",
				name: "Groups.RequestedGroups",
				meta: {
					title: "$vuetify.layout.menu.requestedGroups",
					layout: "default",
				},
				component: () =>
					import(/* webpackChunkName: "requested-groups" */ "@/views/groups/RequestedGroups.vue"),
			},
		]

	},
	{
		path: "/group/:id",
		name: "Group",
		meta: {
			title: "$vuetify.layout.menu.group",
			layout: "default",
		},
		component: () =>
			import(/* webpackChunkName: "about" */ "@/views/Group.vue"),
	},
	{
		path: "/tasks/:id?",
		name: "Tasks",
		meta: {
			title: "$vuetify.layout.menu.taskList",
			layout: "one-column",
		},
		component: () =>
			import(/* webpackChunkName: "tasks" */ "@/views/Tasks.vue"),
	},
	{
		path: "/notes",
		name: "Notes",
		meta: {
			title:  "$vuetify.layout.menu.notes",
			layout: "default",
		},
		component: () =>
			import(/* webpackChunkName: "notes" */ "@/views/Notes.vue"),
	},
	{
		path: "/leanovatica",
		name: "Leanovatica",
		meta: {
			title: "Leanovatica",
			layout: "default",
		},
		component: () =>
			import(
				/* webpackChunkName: "leanovatica" */ "@/views/Leanovatica.vue"
			),
	},
	{
		path: "/saved",
		name: "Saved",
		meta: {
			title:  "$vuetify.layout.menu.saved",
			layout: "default",
		},
		component: () =>
			import(/* webpackChunkName: "saved" */ "@/views/Saved.vue"),
	},
	{
		path: "/problems",
		name: "Problems",
		meta: {
			title:  "$vuetify.layout.menu.problems",
			layout: "default",
		},
		component: () =>
			import(/* webpackChunkName: "problems" */ "@/views/Problems.vue"),
	},
	{
		path: "/polls",
		name: "Polls",
		meta: {
			title:  "$vuetify.layout.menu.polls",
			layout: "default",
		},
		component: () =>
			import(/* webpackChunkName: "polls" */ "@/views/Polls.vue"),
	},

	{
		path: "/settings/:typeOfSettings?",
		name: "Settings",
		meta: {
			title:  "$vuetify.layout.menu.settings",
			layout: "default",
		},
		component: () =>
			import(/* webpackChunkName: "settings" */ "@/views/Settings.vue"),
	},
	{
		path: "/profile/:userID",
		name: "Profile",
		meta: {
			title:  "$vuetify.layout.menu.profile",
			layout: "default",
		},
		component: () =>
			import(/* webpackChunkName: "profile" */ "@/views/Profile.vue"),
	},
	{
		path: "/notifications/:folder?",
		name: "Notifications",
		meta: {
			title:  "$vuetify.layout.menu.notifications",
			layout: "default",
		},
		component: () =>
			import(
				/* webpackChunkName: "notifications" */ "@/views/Notifications.vue"
			),
	},
	{
		path: "/post/:id",
		name: "Post",
		meta: {
			title:  "$vuetify.layout.menu.post",
			layout: "default",
		},
		component: () =>
			import(/* webpackChunkName: "post" */ "@/views/SinglePost.vue"),
	},
	{
		path: "/comment/:id",
		name: "Comment",
		meta: {
			title: "$vuetify.layout.menu.comment",
			layout: "default",
		},
		component: () =>
			import(/* webpackChunkName: "post" */ "@/views/SinglePost.vue"),
	},
	{
		path: "/abuses",
		name: "Abuses",
		meta: {
			title: "$vuetify.layout.menu.abuses",
			layout: "default",
		},
		component: () =>
			import(/* webpackChunkName: "abuses" */ "@/views/Abuses.vue"),
	},
	{
		path: "/search-results",
		name: "SearchResults",
		meta: {
			title: "$vuetify.layout.menu.searchResults",
			layout: "default",
		},
		component: () =>
			import(/* webpackChunkName: "search" */ "@/views/SearchResults.vue"),
	},
	{
		path: "/chat/:hash?",
		name: "Chat",
		meta: {
			title: "$vuetify.layout.menu.chat",
			layout: "one-column",
		},
		component: () =>
			import(/* webpackChunkName: "chat" */ "@/views/Chat.vue"),
	},
	{
		path: "/share",
		name: "Share",
		meta: {
			title: "$vuetify.layout.menu.share",
			layout: "default",
		},
		component: () =>
			import(/* webpackChunkName: "share" */ "@/views/Share.vue"),
	},
	{
		path: "*",
		component: NotFound,
		meta: {
			title: "$vuetify.layout.menu.notFound",
			layout: "default",
		},
	},
];
